import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { SZ_SCORING_LABELS, SzScoringValue } from './sz-score-chip.types';

@Component({
  selector: 'sz-score-chip',
  templateUrl: './sz-score-chip.component.html',
  styleUrls: ['./sz-score-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzScoreChipComponent {
  readonly scoring: InputSignal<SzScoringValue> = input.required<SzScoringValue>();

  readonly label: Signal<string> = computed((): string => SZ_SCORING_LABELS[this.scoring()]);
}
